import React from 'react';
import { ThemeApp } from '../../theme/theme';
import * as S from './ProductPage.styles';
import {
  TEXTURA_URI,
  SEDDI_URI,
  AUTHOR_URI,
  DECORATOR_URI,
  FITROOM_URI,
} from '../../constants/constants';
import { FormContainer } from '../../components/formContainer/FormContainer';

const loginTo = (name: string) => {
  switch (name) {
    case 'author':
      window.location.href = AUTHOR_URI;
      break;
    case 'decorator':
      window.location.href = DECORATOR_URI;
      break;
    case 'fitroom':
      window.location.href = FITROOM_URI;
      break;
    case 'textura':
      window.location.href = TEXTURA_URI;
      break;
    case 'seddi':
    default:
      window.location.href = SEDDI_URI;
      break;
  }
};

const products = [
  {
    name: 'Decorator',
    description: 'Where blank apparel, distributors, and decorators meet in 3D.',
    themeColor: ThemeApp.color.sd1,
    secondaryColor: ThemeApp.color.sd2,
  },
  {
    name: 'Author',
    description: '3D design software for apparel manufacturers and brands.',
    themeColor: ThemeApp.color.sa1,
    secondaryColor: ThemeApp.color.sa2,
  },
  {
    name: 'Textura',
    description: 'Power your 3D apparel with in-house digital fabrics.',
    themeColor: ThemeApp.color.st1,
    secondaryColor: ThemeApp.color.st2,
  },
];

const ProductPage: React.FC<{}> = () => {
  return (
    <FormContainer
      title=''
      text='Choose the product you want to login to.'
      brandName={'seddi'}
      panelPosition='left'
      mode={'sidePanel'}
      loading={false}
    >
      <S.MessageFieldContainer>
        {products.map((product) => (
          <S.Card
            key={product.name}
            $themeColor={product.themeColor}
            $secondaryColor={product.secondaryColor}
            onClick={() => loginTo(product.name.toLowerCase())}
          >
            <S.CardButton onClick={() => (window.location.href = '#')}>{product.name}</S.CardButton>
            <S.CardDescription>{product.description}</S.CardDescription>
          </S.Card>
        ))}
      </S.MessageFieldContainer>
    </FormContainer>
  );
};

export default ProductPage;
